module.exports = __webpack_public_path__ + "img/keuntungan@2x.dc91b1d5.png";